<template>
  <div class="page-content">
    <page-template
      ref="supplierTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="editColumns"
      :detailColumns="detailColumns"
      @getDetail="getDetail"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower';

  export default {
    mixins: [userPower],
    components: {
      pageTemplate
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '供应商名称/编码',
              prop: 'otherName',
              type: 'input',
              isFuzzy: true,
              placeholder: '请输入供应商名称/编码',
              labelWidth: '110'
            }
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert'
          },
          {
            label: '同步',
            code: 'sync',
            callback: this.sync,
            filter: () => {
              return false
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update'
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate
          }
        ],
        // 表格信息配置
        tableOptions: {
          showSelect: true,
          indexShow: true, // 是否显示索引
          columns: [
            {label: '供应商编码', prop: 'code', width: '120', align: 'center'},
            {label: '供应商名称', prop: 'name', width: '190', align: 'center'},
            {
              label: '经营方式',
              prop: 'type',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('asSupplier.type')
            },
            {
              label: '状态',
              prop: 'status',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('asSupplier.status')
            },
            {label: '联系人', prop: 'contact', width: '120', align: 'center'},
            {label: '联系方式', prop: 'phone', width: '120', align: 'center'},
            {
              label: '创建时间',
              prop: 'createDttm',
              width: '190',
              align: 'center'
            }
            // {
            //   label: "备注",
            //   prop: "remarks",
            //   width: "125",
            //   align: "center",
            // },
          ],
          url: api.archives.supplier
        },
        // 添加字段
        addColumns: {
          labelWidth: '120px',
          span: 12,
          columns: [
            {
              label: '供应商名称',
              type: 'input',
              prop: 'name',
              maxLength: 16,
              rule: [
                {required: true, message: '请输入供应商名称', trigger: 'blur'}
              ],
              change: this.checkName
            },
            {
              label: '联系人',
              type: 'input',
              prop: 'contact',
              maxLength: 16,
              rule: [
                {required: false, message: '请输入联系人', trigger: 'blur'}
              ]
            },
            {
              label: '联系人电话',
              type: 'input',
              prop: 'phone',
              maxLength: 11,
              rule: [
                {required: false, message: '请输入手机号码', trigger: 'blur'},
                {pattern: this.$utils.reg.phone, message: '请输入正确的11位手机号码', trigger: 'blur'}
              ]
            },
            {
              label: '经营方式',
              type: 'radio',
              prop: 'type',
              defaultValue: 10,
              data: this.$utils.getCacheStatus('asSupplier.type'),
              change: this.typeChange,
              rule: [
                {required: true, message: '请选择经营方式', trigger: 'blur'}
              ]
            },
            {
              label: '联营扣率',
              type: 'inputNumber',
              prop: 'deductionRate',
              hidden: true,
              precision: 2,
              rule: [
                {required: false, message: '请输入小数扣率', trigger: 'blur'}
              ]
            },
            {
              label: '保底金额',
              type: 'inputNumber',
              prop: 'floorsAmount',
              max: 99999.99,
              hidden: true,
              precision: 2
            },
            {
              label: '供应商状态',
              type: 'radio',
              prop: 'status',
              defaultValue: 10,
              data: this.$utils.getCacheStatus('asSupplier.status'),
              rule: [
                {required: true, message: '请选择供应商状态', trigger: 'blur'}
              ],
              isAllline: true
            },
            {
              label: '备注',
              type: 'textarea',
              span: 22,
              maxLength: 16,
              prop: 'remarks'
            }
          ], // 表单label
          url: api.archives.supplier
        },
        // 编辑字段
        editColumns: {
          labelWidth: '120px',
          span: 12,
          columns: [
            {
              label: '供应商编码',
              type: 'input',
              prop: 'code',
              disabled: true
            },
            {
              label: '供应商名称',
              type: 'input',
              prop: 'name',
              maxLength: 16,
              rule: [
                {required: true, message: '请输入供应商名称', trigger: 'blur'}
              ],
              change: this.checkNameEdit
            },
            {
              label: '联系人',
              type: 'input',
              prop: 'contact',
              maxLength: 16,
              rule: [
                {required: false, message: '请输入联系人', trigger: 'blur'}
              ]
            },
            {
              label: '联系人电话',
              type: 'input',
              prop: 'phone',
              maxLength: 11,
              rule: [
                {required: false, message: '请输入手机号码', trigger: 'blur'},
                {pattern: this.$utils.reg.phone, message: '请输入正确的11位手机号码', trigger: 'blur'}
              ]
            },
            {
              label: '经营方式',
              type: 'radio',
              prop: 'type',
              defaultValue: 10,
              data: this.$utils.getCacheStatus('asSupplier.type'),
              change: this.typeChange,
              rule: [
                {required: true, message: '请选择经营方式', trigger: 'blur'}
              ]
            },
            {
              label: '联营扣率',
              type: 'inputNumber',
              prop: 'deductionRate',
              hidden: true,
              precision: 2,
              rule: [
                {required: false, message: '请输入小数扣率', trigger: 'blur'}
              ]
            },
            {
              label: '保底金额',
              type: 'inputNumber',
              prop: 'floorsAmount',
              hidden: true,
              max: 99999.99,
              precision: 2
            },
            {
              label: '供应商状态',
              type: 'radio',
              prop: 'status',
              defaultValue: 10,
              data: this.$utils.getCacheStatus('asSupplier.status'),
              rule: [
                {required: true, message: '请选择供应商状态', trigger: 'blur'}
              ],
              isAllline: true
            },
            {
              label: '备注',
              type: 'textarea',
              span: 22,
              maxLength: 16,
              prop: 'remarks'
            }
          ], // 表单label
          url: api.archives.supplier
        },
        detailColumns: {
          span: 8,
          labelWidth: '130',
          columns: [
            {label: '供应商编码', prop: 'code'},
            {label: '供应商名称', prop: 'name'},
            {label: '联系人', prop: 'contact'},
            {label: '联系方式', prop: 'phone'},
            {
              label: '经营方式',
              prop: 'phone',
              enumData: this.$utils.getCacheStatus('asSupplier.type')
            },
            {
              label: '状态',
              prop: 'status',
              enumData: this.$utils.getCacheStatus('asSupplier.status')
            },
            {label: '创建时间', prop: 'createDttm'}
          ],
          url: api.archives.supplier
        },
        isReaptName: false,
        editData: null
      };
    },
    created() {
      // this.setStore(this.searchOptions.simple);
      // this.setSupplier(this.searchOptions.simple);
    },
    methods: {
      getDetail(val) {
        this.editData = this.$utils.deepClone(val);
      },
      checkFun(name) {
        return new Promise((resolve, reject) => {
          this.$axios.fetchGet(api.archives.supplierName + '?supplierName=' + name, {}).then(res => {
            this.loading = false;
            if (res.code == 200) {
              if (!res.data) {
                this.$message({type: 'warning', message: '名称重复'});
                this.isReaptName = false;
              } else {
                this.isReaptName = true
              }
              resolve(this.isReaptName)
            } else {
              reject()
              this.$message({type: 'error', message: res.msg});
            }
          })
            .catch(err => {
            })
        })
      },
      // 新增 校验名称重复
      checkName(val) {
        this.checkFun(val.name).then(() => {
          if (!this.isReaptName) {
            val.name = ''
          }
        })
      },
      // 编辑 校验名称重复
      checkNameEdit(val) {
        if (this.editData.name && this.editData.name != val.name) {
          this.checkFun(val.name).then(() => {
            if (!this.isReaptName) {
              val.name = this.editData.name
            }
          })
        }
      },
      sync() {
        // 门店集合
        let ids = this.$refs.supplierTemplate.getSimpleParams().storeId;
        if (!ids) {
          this.$message({message: '请选择门店后进行同步', type: 'warning'});
          return;
        }
        // 需要同步的数据
        let tableRows = this.$refs.supplierTemplate.getTableSelectRow();
        if (tableRows.length === 0) {
          this.$message({message: '请勾选一条数据后进行同步', type: 'warning'});
          return;
        }
        this.$axios
          .fetchPost(api.archives.supplier + '/sync', {
            supplierList: tableRows, ids: ids
          })
          .then((data) => {
            if (data.code === 200 && data.data) {
              this.$notify({
                type: "success",
                title: '同步操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '同步成功', type: 'success'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch((err) => {
            this.$message({message: '请求失败！', type: 'error'});
          });
      },
      typeChange(data) {
        if (!data.id) {
          if (data.type === 10) {
            this.$refs['supplierTemplate'].addColumns.columns.filter(item => item.prop === 'deductionRate')[0].hidden = true;
            this.$refs['supplierTemplate'].addColumns.columns.filter(item => item.prop === 'floorsAmount')[0].hidden = true;
          } else {
            this.$refs['supplierTemplate'].addColumns.columns.filter(item => item.prop === 'deductionRate')[0].hidden = false;
            this.$refs['supplierTemplate'].addColumns.columns.filter(item => item.prop === 'floorsAmount')[0].hidden = false;
          }
        } else {
          if (data.type === 10) {
            this.$refs['supplierTemplate'].editColumns.columns.filter(item => item.prop === 'deductionRate')[0].hidden = true;
            this.$refs['supplierTemplate'].editColumns.columns.filter(item => item.prop === 'floorsAmount')[0].hidden = true;
          } else {
            this.$refs['supplierTemplate'].editColumns.columns.filter(item => item.prop === 'deductionRate')[0].hidden = false;
            this.$refs['supplierTemplate'].editColumns.columns.filter(item => item.prop === 'floorsAmount')[0].hidden = false;
          }
        }

      }
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Supplier.vue